import React from 'react';
import styled from 'styled-components';

import { useAnalytics } from '../../helpers/analytics.helper';
import { Analytics } from '../../shared/types';
import { ReactTable } from '../../types';
import LikeButton from '../like/LikeButton';
import LikeOverlay from '../like/LikeOverlay';
import { regionToCategory } from '../stock/stockCategory';
import StockCodeSpan from './StockCodeSpan';

const LikeButtonStyles = styled.div`
  margin-right: 0.3rem;
`;

interface stockCodeCellProps {
  showPlaneValue?: boolean;
}

const StockCodeCell: React.FC<ReactTable.CellProps & stockCodeCellProps> = ({
  dispatch: reactTableDispatch,
  row: { isExpanded, index },
  cell: { value },
  showPlaneValue,
}) => {
  const exclusivelyToggleExpanded = (index, isExpanded) => {
    reactTableDispatch({
      type: 'setExpanded',
      expanded: { [index]: isExpanded },
    });
  };
  const [queue] = useAnalytics();

  return showPlaneValue ? (
    <div
      className="clickable"
      onClick={() => {
        exclusivelyToggleExpanded(index, isExpanded === 10 ? 0 : 10);
        if (isExpanded !== 10) {
          queue(Analytics.ActionEnum.ClickHistoryPrices, value);
        }
      }}
    >
      <span>{value}</span>
    </div>
  ) : (
    <>
      <LikeButtonStyles>
        <LikeButton
          category={regionToCategory(value.region)}
          ticker={value.stockCode}
        />
      </LikeButtonStyles>
      <LikeOverlay stockCode={value.stockCode}>
        <div
          className="clickable"
          onClick={() => {
            exclusivelyToggleExpanded(index, isExpanded === 10 ? 0 : 10);
            if (isExpanded !== 10) {
              queue(Analytics.ActionEnum.ClickHistoryPrices, value.stockCode);
            }
          }}
        >
          <StockCodeSpan value={value} />
        </div>
      </LikeOverlay>
      {value.unlike !== undefined && !!value.unlike && (
        <div className="stock-code-corner-red"></div>
      )}
      {value.unlike !== undefined && value.unlike === 0 && (
        <div className="stock-code-corner-green"></div>
      )}
    </>
  );
};

export default StockCodeCell;
